import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as sopConfigAPI from 'api/Settings/sopconfig';
import { TYPE_OF_SOP_PAGE } from 'pages/setting/Tabs/Sop/constants';
import { TYPE_OF_FIELD_IN_COLUMN } from 'utils/scorecard';

const initalState = {
  pageSize: 10,
  currentPage: 1,
  selectedPage: TYPE_OF_SOP_PAGE.MAIN,
  category: {
    data: null,
    totalRecords: 0,
    selectedCategory: null,
    ui: {
      loading: false,
      msg: ''
    },
    column: [
      // { title: '#', key: 'id', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
      { title: 'Name', key: 'name', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
      { title: 'Priority Index', key: 'priority_index', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
      { title: 'Created_AT', key: 'created_at', type: TYPE_OF_FIELD_IN_COLUMN.DATE, width: 120 },
      { title: 'Action', key: 'Action', type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
    ],
    status: 'init'
  },
  sop: {
    data: null,
    allFeatureTypes: [],
    totalRecords: 0,
    selectedSop: null,
    ui: {
      loading: false,
      msg: ''
    },
    column: [
      // { title: '#', key: 'id', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
      { title: 'Name', key: 'name', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
      // { title: 'Slug', key: 'slug', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      { title: 'Sop Type', key: 'sop_types', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      // { title: 'Feature Type', key: 'sop_feature_type', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      { title: 'Is_Filter', key: 'is_filter', type: TYPE_OF_FIELD_IN_COLUMN.BOOLEAN, width: 120 },
      { title: 'Is_Enabled', key: 'is_enabled', type: TYPE_OF_FIELD_IN_COLUMN.BOOLEAN, width: 120 },
      { title: 'Is_Include_In_CQ', key: 'is_include_in_cq', type: TYPE_OF_FIELD_IN_COLUMN.BOOLEAN, width: 120 },
      // { title: 'Design Type', key: 'design_type', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      // { title: 'Related To', key: 'relate_to', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      // { title: 'player_component', key: 'player_component', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      // { title: 'Processing Type', key: 'processing_type', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      { title: 'Team', key: 'team', type: TYPE_OF_FIELD_IN_COLUMN.ARRAY, width: 120 },
      // { title: 'Updated At', key: 'updated_at', type: TYPE_OF_FIELD_IN_COLUMN.DATE, width: 120 },
      { title: 'Action', key: 'Action', type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
    ],
    status: 'init'
  },
  sopParams: {
    data: null,
    totalRecords: 0,
    ui: {
      loading: false,
      msg: ''
    },
    column: [
      { title: 'Team', key: 'team.name', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
      {
        title: 'Feature Type',
        key: 'sop_feature_type_payload_parameter.sop_feature_type.name',
        type: TYPE_OF_FIELD_IN_COLUMN.STRING,
        width: 120
      },
      { title: 'Parameter', key: 'sop_feature_type_payload_parameter.name', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      { title: 'Data Type', key: 'sop_feature_type_payload_parameter.datatype', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      { title: 'value', key: 'value', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
      { title: 'Action', key: 'Action', type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
    ],
    status: 'init'
  }
};

const getSopCategory = createAsyncThunk('settings/features/getSopCategories', async (filter) => {
  const res = await sopConfigAPI.getSopCategory(filter);
  return res.data?.data;
});

const createSopCategory = createAsyncThunk('settings/features/createSopCategories', async (params) => {
  const res = await sopConfigAPI.createSopCategory(params);
  return res.data?.data;
});

const updateSopCategory = createAsyncThunk('settings/features/updateSopCategories', async (params) => {
  const res = await sopConfigAPI.updateSopCategory(params);
  return res.data?.data;
});

const deleteSopCategory = createAsyncThunk('settings/features/deleteSopCategories', async (id) => {
  const res = await sopConfigAPI.deleteSopCategory(id);
  return res.data?.data;
});

const getSop = createAsyncThunk('settings/features/getSop', async (filter) => {
  const res = await sopConfigAPI.getSop(filter);
  return res.data?.data;
});

const createSop = createAsyncThunk('settings/features/createSop', async (params) => {
  const res = await sopConfigAPI.createSop(params);
  return res.data?.data;
});

const updateSop = createAsyncThunk('settings/features/updateSop', async (params) => {
  const res = await sopConfigAPI.updateSop(params);
  return res.data?.data;
});

const deleteSop = createAsyncThunk('settings/features/deleteSop', async (id) => {
  const res = await sopConfigAPI.deleteSop(id);
  return res.data?.data;
});

const getAllFeatureTypes = createAsyncThunk('settings/features/allFeatureTypes', async () => {
  const res = await sopConfigAPI.getAllFeatureTypes();
  return res.data?.data;
});

const getSopParams = createAsyncThunk('settings/features/getSopParams', async (filter) => {
  const res = await sopConfigAPI.getSopParams(filter);
  return res.data?.data;
});

const updateSopParams = createAsyncThunk('settings/features/updateSopParams', async (params) => {
  const res = await sopConfigAPI.updateSopParams(params);
  return res.data?.data;
});

const sopConfig = createSlice({
  name: 'sopConfig',
  initialState: initalState,

  reducers: {
    resetState: () => {
      return initalState;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setSelectedPage: (state, action) => {
      state.selectedPage = action.payload;
    },
    setSelectedCategory: (state, action) => {
      state.category.selectedCategory = action.payload;
    },
    setSelectedSop: (state, action) => {
      state.sop.selectedSop = action.payload;
    },
    resetSopData: (state) => {
      state.sop.data = [];
    }
  },
  extraReducers: {
    [getSopCategory.pending]: (state) => {
      state.category.status = 'init';
      state.category.ui.loading = true;
    },

    [getSopCategory.fulfilled]: (state, action) => {
      state.category.status = 'idle';
      state.category.ui.loading = false;
      state.category.data = action.payload.results;
      state.category.totalRecords = action.payload.count;
    },

    [getSopCategory.rejected]: (state, action) => {
      state.category.status = 'error';
      state.category.error = action.error.message;
      state.category.ui.loading = false;
    },

    [createSopCategory.pending]: (state) => {
      state.category.status = 'init';
      state.category.ui.loading = true;
    },

    [createSopCategory.fulfilled]: (state) => {
      state.category.status = 'idle';
      state.category.ui.loading = false;
    },

    [createSopCategory.rejected]: (state, action) => {
      state.category.status = 'error';
      state.category.error = action.error.message;
      state.category.ui.loading = false;
    },

    [updateSopCategory.pending]: (state) => {
      state.category.status = 'init';
      state.category.ui.loading = true;
    },

    [updateSopCategory.fulfilled]: (state, action) => {
      state.category.status = 'idle';
      state.category.ui.loading = false;
      const updatedData = state.category.data.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }
        return item;
      });
      state.category.data = updatedData;
    },

    [updateSopCategory.rejected]: (state, action) => {
      state.category.status = 'error';
      state.category.error = action.error.message;
      state.category.ui.loading = false;
    },

    [deleteSopCategory.pending]: (state) => {
      state.category.status = 'init';
      state.category.ui.loading = true;
    },

    [deleteSopCategory.fulfilled]: (state) => {
      state.category.status = 'idle';
      state.category.ui.loading = false;
    },

    [deleteSopCategory.rejected]: (state, action) => {
      state.category.status = 'error';
      state.category.error = action.error.message;
      state.category.ui.loading = false;
    },

    [getSop.pending]: (state) => {
      state.sop.status = 'init';
      state.sop.ui.loading = true;
    },

    [getSop.fulfilled]: (state, action) => {
      state.sop.status = 'idle';
      state.sop.ui.loading = false;
      state.sop.data = action.payload.results;
      state.sop.totalRecords = action.payload.count;
    },

    [getSop.rejected]: (state, action) => {
      state.sop.status = 'error';
      state.sop.error = action.error.message;
      state.sop.ui.loading = false;
    },

    [createSop.pending]: (state) => {
      state.sop.status = 'init';
      state.sop.ui.loading = true;
    },

    [createSop.fulfilled]: (state) => {
      state.sop.status = 'idle';
      state.sop.ui.loading = false;
    },

    [createSop.rejected]: (state, action) => {
      state.sop.status = 'error';
      state.sop.error = action.error.message;
      state.sop.ui.loading = false;
    },

    [updateSop.pending]: (state) => {
      state.sop.status = 'init';
      state.sop.ui.loading = true;
    },

    [updateSop.fulfilled]: (state, action) => {
      state.sop.status = 'idle';
      state.sop.ui.loading = false;
      const updatedData = state.sop.data.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }
        return item;
      });
      state.sop.data = updatedData;
    },

    [updateSop.rejected]: (state, action) => {
      state.sop.status = 'error';
      state.sop.error = action.error.message;
      state.sop.ui.loading = false;
    },

    [deleteSop.pending]: (state) => {
      state.sop.status = 'init';
      state.sop.ui.loading = true;
    },

    [deleteSop.fulfilled]: (state) => {
      state.sop.status = 'idle';
      state.sop.ui.loading = false;
    },

    [deleteSop.rejected]: (state, action) => {
      state.sop.status = 'error';
      state.sop.error = action.error.message;
      state.sop.ui.loading = false;
    },

    [getAllFeatureTypes.fulfilled]: (state, action) => {
      state.sop.status = 'idle';
      state.sop.allFeatureTypes = action.payload;
      state.sop.ui.loading = false;
    },

    [getSopParams.pending]: (state) => {
      state.sopParams.status = 'init';
      state.sopParams.ui.loading = true;
    },

    [getSopParams.fulfilled]: (state, action) => {
      state.sopParams.status = 'idle';
      state.sopParams.ui.loading = false;
      state.sopParams.data = action.payload;
      state.sopParams.totalRecords = action.payload?.count;
    },

    [getSopParams.rejected]: (state, action) => {
      state.sopParams.status = 'error';
      state.sopParams.error = action.error.message;
      state.sopParams.ui.loading = false;
    },

    [updateSopParams.pending]: (state) => {
      state.sopParams.status = 'init';
      state.sopParams.ui.loading = true;
    },

    [updateSopParams.fulfilled]: (state) => {
      state.sopParams.status = 'idle';
      state.sopParams.ui.loading = false;
    },

    [updateSopParams.rejected]: (state, action) => {
      state.sopParams.status = 'error';
      state.sopParams.error = action.error.message;
      state.sopParams.ui.loading = false;
    }
  }
});

export const { setCurrentPage, setPageSize, setSelectedPage, setSelectedCategory, setSelectedSop, resetSopData } = sopConfig.actions;

export default sopConfig.reducer;

export {
  getSopCategory,
  createSopCategory,
  updateSopCategory,
  deleteSopCategory,
  getSop,
  createSop,
  updateSop,
  deleteSop,
  getAllFeatureTypes,
  getSopParams,
  updateSopParams
};
